import React, { PureComponent, Fragment } from 'react'
import { TableRow, TableCell, Button } from '@material-ui/core'

export default class PricingTemplateItem extends PureComponent {
  onSave = () => {}

  onCancel = () => {}

  render() {
    const { template = {}, editMode = false, permitted } = this.props
    return (
      <TableRow>
        <TableCell>{template.name || ''}</TableCell>
        <TableCell>{template.unitType === 'grams' ? 'Grams' : 'Units'}</TableCell>
        <TableCell>{template.active ? 'Active' : 'Inactive'}</TableCell>
        <TableCell>
          {!editMode ? (
            <Button className="primary-button margin" onClick={this.props.onView}>
              View
            </Button>
          ) : null}
          {permitted ? (
            <Fragment>
              <Button className="primary-button margin" onClick={this.props.onEdit}>
                Edit
              </Button>
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            </Fragment>
          ) : null}
        </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PricingTemplate/PricingTemplateItem.js